import React from 'react';
import ReactDOM from 'react-dom';
import { ChartSettings, ChartSidebarContainer, ChartTabsContainer, ChartTitle } from '../styles';
import { PieChartSettings } from './pieChartSettings';
import { CHART_TRANSLATION } from '../translationValues';
import { CHART_TYPES } from '../chartConstants';
import { BarChartSettings } from './barChartSettings';

const ChartSidebar = props => {
  const { element, t, globalVariables } = props;
  const { type } = element.contents;

  let SettingsComponent = PieChartSettings;

  if (type === CHART_TYPES.BAR || type === CHART_TYPES.LINE) {
    SettingsComponent = BarChartSettings;
  }

  return (
    <ChartSidebarContainer id="chart-sidebar-container">
      <ChartTitle>
        {t(CHART_TRANSLATION.CHART_SETTINGS.key, CHART_TRANSLATION.CHART_SETTINGS.value)}
      </ChartTitle>
      <ChartSettings>
        <ChartTabsContainer>
          <SettingsComponent globalVariables={globalVariables} {...props} />
        </ChartTabsContainer>
      </ChartSettings>
    </ChartSidebarContainer>
  );
};

export const ChartSettingsSidebar = props => {
  return ReactDOM.createPortal(
    <ChartSidebar {...props} />,
    document.getElementById('sidebar-absolute-container'),
  );
};
